import React, { Component } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import backend from "../../api";
import { Notification } from "../../utils";

const ForgetPasswordMem = () => {
  const { handleSubmit, register, errors, getValues } = useForm();
  const changePassword = () => {
    const val = getValues();

    if (val) {
      backend
        .put("/user/member/password/forget", val)
        .then(({ data: { data, message } }) => {
          const status = new Notification();
          status.set_toast("success", message);
          status.show_toast();
          window.location.reload();
        })
        .catch((err) => console.log(err.response.data.message));
    }
  };

  return (
    <div>
      <Breadcrumb title={"forget password"} />

      {/*Forget Password section*/}
      <section className="pwd-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <h2>Forget Your Password?</h2>
              <form className="theme-form">
                <div className="form-row">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Enter Your Email"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                        pattern: {
                          value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          message: "This must be a valid Email",
                        },
                      })}
                    />
                    <label htmlFor="email" className="error">
                      {errors.email && errors.email.message}
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      placeholder="Enter Your Name"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="name" className="error">
                      {errors.name && errors.name.message}
                    </label>
                  </div>
                </div>
                <br />
                <h4>Security Questions</h4>

                <div className="form-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label htmlFor='color'>Enter your favorite color?</label> */}
                      <input
                        type="text"
                        className="form-control mb-0"
                        id="color"
                        name="member_favorite_color"
                        placeholder="favorite color"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="color" className="error">
                        {errors.member_favorite_color &&
                          errors.member_favorite_color.message}
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label htmlFor='bestfriend'>
                            Enter your bestfriend name?
                          </label> */}
                      <input
                        type="text"
                        className="form-control mb-0"
                        id="bestfriend"
                        name="member_bestfriend"
                        placeholder="Enter name"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="bestfriend" className="error">
                        {errors.member_bestfriend &&
                          errors.member_bestfriend.message}
                      </label>
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-solid"
                  onClick={handleSubmit(changePassword)}
                >
                  Submit
                </button>
                <Link className="ml-2" to={`${process.env.PUBLIC_URL}/contact`}>
                  need help?
                </Link>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgetPasswordMem;
